<template>
    <transition name="fade">
        <div class="toastMessageBox" v-show="show">
            <img v-show="type == 'success'" src="//image.gamersky.com/app/icons6.0/icon_TostLoading_30x30@3x.png" />
            <img v-show="type == 'warning'" src="//image.gamersky.com/webimg13/zhuanti/2022NewYear/toastError.png" />
            <div>
                {{ message }}
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "toastMessage",
    props: {
        type: String
    },
    data() {
        return {
            message: "",
            show: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.toastMessageBox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 16px;
    font-size: 14px;
    border-radius: 6px;
    text-align: center;
    z-index: 100000;
    width: auto;
    min-height: 90px;
    box-sizing: border-box;
    img {
        display: block;
        width: 28px;
        height: 28px;
        object-fit: cover;
        margin-bottom: 8px; 
    }
}


</style>
